import { useTranslations } from 'next-intl'

import { usePropertyTypeMap } from '@/entities/room'
import { cn } from '@/shared/lib'

import { Props } from './index.pc'
import { Heading, Item, Label, List, Value } from '../../common'

export const MobileProperty = ({
  propertyType,
  pyeongSize,
  squareMeterSize,
  className,
}: Props & { className?: string }) => {
  const t = useTranslations('room_detail')
  const { PROPERTY_TYPE_MAP } = usePropertyTypeMap()

  return (
    <div className={cn('flex-1 space-y-4', className)}>
      <Heading size="small">{t('building_type_area.title')}</Heading>
      <List spacing="small" className="typo-body2 text-gray-900">
        <Item className="justify-between">
          <Label icon="propertyType" className="font-semibold">
            {t('building_type_area.building_type')}
          </Label>
          <Value>{PROPERTY_TYPE_MAP[propertyType]}</Value>
        </Item>
        <Item className="justify-between gap-2">
          <Label icon="pyeongSize" className="font-semibold">
            {t('building_type_area.area')}
          </Label>
          <Value>
            {t('area.pyeong', {
              pyeongSize,
              squareMeterSize: Math.round(squareMeterSize),
            })}
          </Value>
        </Item>
      </List>
    </div>
  )
}
